import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import {
    Checkbox, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, TableSortLabel, TablePagination, TableFooter
} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import Info from '@mui/icons-material/Info';
import AddIcon from '@mui/icons-material/Add';
import CopyrightIcon from '@mui/icons-material/Copyright';
import RefreshIcon from '@mui/icons-material/Refresh';
import ApiIcon from '@mui/icons-material/Api';
import { Tooltip } from '@mui/material';
import { useLocation, Link } from 'react-router-dom';
import Modal from '@mui/material/Modal';
import { Box } from '@mui/material';
// import SalePrint from './Print';
import PrintIcon from '@mui/icons-material/Print';
import ReactDOM from 'react-dom';
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logo from "./Al-Hadi.png";

function PaymentAndReceiptIndex() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);

    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const history = useHistory(); // Access the navigation history
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [isFocused, setIsFocused] = useState(false);

    const { isAuthenticated, companyId, branchId, permissions, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Accounts');
    const hasEditMasterPermission = permissions.includes('Edit Accounts');
    const hasDeleteMasterPermission = permissions.includes('Delete Accounts');
    const [open, setOpen] = useState(false);
    const [requestedItemdata, setrequestedItemdata] = useState([]);
    const [purchaseRequestdatacount, setpurchaseRequestdatacount] = useState('');
    const location = useLocation();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const shouldReload = localStorage.getItem('shouldReload') === 'true';

        // Only reload data if navigated from PurchaseOrderCreate and flag is set
        if (location.state?.from === '/PaymentAndReceiptCreate' && shouldReload) {
            localStorage.removeItem('shouldReload'); // Clear the flag after use
            window.location.reload();
        }
        else if (location.state?.from === '/PaymentAndReceiptEdit' && shouldReload) {
            localStorage.removeItem('shouldReload'); // Clear the flag after use
            window.location.reload();
        }
        else if (location.state?.from === '/PaymentAndReceiptDetails' && shouldReload) {
            localStorage.removeItem('shouldReload'); // Clear the flag after use
            window.location.reload();
        }
        else {
            // Populate data without reloading for other cases
            setFromDate(getFormattedStartDate());
            setToDate(getFormattedCurrentDate());
        }
    }, [location]);

    const handleClose = () => {
        setOpen(false);
    };

    // Define the modal style
    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
        bgcolor: 'white',
        boxShadow: 24,
        borderRadius: '10px'
    };

    useEffect(() => {
        // Check if reload is needed based on the flag set in localStorage
        const shouldReload = localStorage.getItem('shouldReloadCreatePage') === 'true';

        if (shouldReload) {
            localStorage.removeItem('shouldReloadCreatePage'); // Remove the flag after use
            window.location.reload(); // Reload the page once
        }

        // Authentication and token expiration handling
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

        fetchTableData();
        // Other initializations, if any
    }, [isAuthenticated, token, logout,companyId,branchId,fromDate,toDate]);

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };

    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        setFromDate(selectedDate);
    };

    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        setToDate(selectedDate);
    };

    const fetchTableData = async () => {
        setLoading(true);
        setData([]);
        try {
            const response = await fetchData('PaymentAndReceiptApi', `/${companyId}/${branchId}/${fromDate}/${toDate}`, token);
            if (response.responseCode === '1111') {
                setData(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Receipt Details:', error);
            if (error.response && error.response.status === 401) {
                logout();
                history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
            }
        } finally {
            setLoading(false);
        }

    };

    const handleDelete = async () => {
        deleteData('PaymentAndReceiptApi', `${deleteItemId}`, token)
            .then((response) => {
                fetchTableData();
                setDeleteItemId(null);
                setConfirmDialogOpen(false);
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (itemId) => {
        activateData('PaymentAndReceiptApi', `${itemId}`, token)
            .then(() => {
                fetchTableData();
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    function formatDate(dateString) {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        const formattedDate = new Date(dateString).toLocaleDateString('en-GB', options);
        return formattedDate;
    }

    const commonButtonStyles = {
        height: '36px',
        marginLeft: '10px',
        marginTop: '10px',
        marginRight: '8px',
    };

    const [order, setOrder] = useState('desc');
    const [orderBy, setOrderBy] = useState('PurchaseOrderDate');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const sortedData = stableSort(filteredData, getComparator(order, orderBy));

    const generateInvoice = async (ReceiptId) => {
        try {
            const doc = new jsPDF("p", "mm", "a4");
            const pageWidth = doc.internal.pageSize.getWidth();

            // ===== FETCH DATA =====
            const response = await fetchData('PaymentAndReceiptApi', `/ReceiptPrint/${ReceiptId}`, token);
            const header = response.response_data;
            if (!header) throw new Error("Invalid receipt data.");

            // ===== HARD CODED COMPANY INFO =====
            doc.setFont("times", "normal");
            doc.setFontSize(11);
            doc.text("C.R.No: 133768/8", 15, 20);
            doc.text("GSM: 99350447 / 99375290 /", 15, 26);
            doc.text("98524923 / 92497852", 15, 32);

            doc.text("Fax : 24712328", pageWidth - 60, 20);
            doc.text("P.O.Box : 1485,", pageWidth - 60, 26);
            doc.text("Jibroo Postal Code : 114,", pageWidth - 60, 32);
            doc.text("Sultanate of Oman", pageWidth - 60, 38);

            // ===== LOGO =====
            const logoWidth = 75;
            const logoHeight = 25;
            const logoX = (pageWidth - logoWidth) / 2;
            const logoY = 35;
            doc.addImage(logo, "PNG", logoX, logoY, logoWidth, logoHeight);

            // ===== AMOUNT SPLIT (R.O. / BZ.) =====
            const amount = header.Amount || 0;
            const rials = Math.floor(amount);
            const baiza = Math.round((amount - rials) * 100);

            const sectionY = 60;
            const leftX = 20;
            const rightX = pageWidth - 50;

            // ---- LEFT SIDE (R.O. / BZ.) ----
            autoTable(doc, {
                startY: sectionY,
                margin: { left: leftX },
                body: [["R.O.", "BZ."]],
                theme: "plain",
                styles: { halign: "center", fontStyle: "bold", fontSize: 12 },
                columnStyles: {
                    0: { cellWidth: 30 }, // R.O. column width
                    1: { cellWidth: 30 }  // BZ. column width
                }
            });

            autoTable(doc, {
                startY: doc.lastAutoTable.finalY + 2,
                margin: { left: leftX },
                body: [[rials.toString(), baiza.toString().padStart(3, "0")]],
                theme: "grid",
                styles: {
                    halign: "center",
                    fontSize: 14,
                    fontStyle: "bold",
                    lineWidth: 0.2,
                    lineColor: [0, 0, 0],
                    textColor: [0, 0, 0] // ✅ set text color to black
                },
                columnStyles: {
                    0: { cellWidth: 30 }, // R.O.
                    1: { cellWidth: 30 }  // BZ.
                }
            });



            // ---- RIGHT SIDE (Voucher Details) ----
            doc.setFont("times", "normal");
            doc.setFontSize(12);
            doc.text(`No.: ${header.ReferenceNo || ""}`, rightX, sectionY + 8);
            doc.text(`Date: ${header.ReferenceDate ? new Date(header.ReferenceDate).toLocaleDateString('en-GB') : ""}`, rightX, sectionY + 16);

            let y = doc.lastAutoTable.finalY + 12;

            // ===== RECEIVED FROM =====
            doc.setFont("times", "normal");
            doc.text("Received with thanks from Mr/M/s", 15, y);
            doc.setFont("times", "bold");
            doc.text((header.PartyName || "").toUpperCase(), 85, y);
            doc.setLineDash([1, 1], 0);
            doc.line(80, y + 1, pageWidth - 15, y + 1);

            // ===== ON BEHALF OF =====
            y += 8;
            doc.setFont("times", "normal");
            doc.text("On Behalf Of", 15, y);
            doc.setFont("times", "bold");
            doc.text((header.CompanyName || "").toUpperCase(), 55, y);
            doc.line(50, y + 1, pageWidth - 15, y + 1);

            // ===== AMOUNT IN WORDS =====
            y += 8;
            const amountInWords = ConvertAmountToRialBaisa(amount);
            doc.setFont("times", "normal");
            doc.text("The Sum of Rials Omani", 15, y);

            doc.setFont("times", "bold");
            const textX = 65;
            doc.text(amountInWords, textX + 1, y);
            doc.line(textX, y + 1, pageWidth - 15, y + 1);

            // ===== CASH / CHEQUE =====
            y += 12;
            doc.setFont("times", "normal");
            doc.text("By Cash / Cheque No", 15, y);
            doc.line(55, y + 1, 80, y + 1);
            doc.setFont("times", "bold");
            doc.text(header.PaymentType || "Cash", 60, y);

            doc.setFont("times", "normal");
            doc.text("Bank", 100, y);
            doc.line(115, y + 1, 140, y + 1);
            doc.setFont("times", "bold");
            doc.text(header.BankName || "", 112, y);

            doc.text("Date", 160, y);
            doc.setFont("times", "bold");
            doc.text(header.ReferenceDate ? new Date(header.ReferenceDate).toLocaleDateString('en-GB') : "", 175, y);

            // ===== BEING =====
            y += 10;
            doc.setFont("times", "normal");
            //doc.text("Being" header.Remarks, 15, y);
            doc.text(`Being     ${header.Remarks}`, 15, y);
            doc.line(30, y + 1, pageWidth - 15, y + 1);

            // ===== FOOTER =====
            y += 20;
            doc.setFont("times", "normal");
            doc.text("Accountant", 15, y);
            doc.line(40, y + 1, 90, y + 1);

            doc.text("Receiver's Signature", 140, y);
            doc.line(180, y + 1, pageWidth - 15, y + 1);

            // ===== OPEN & PRINT =====
            const blob = doc.output('blob');
            const blobUrl = URL.createObjectURL(blob);
            const printWindow = window.open(blobUrl, '_blank');
            if (printWindow) {
                printWindow.onload = () => {
                    printWindow.focus();
                    printWindow.print();
                };
            }
        } catch (error) {
            console.error("Error generating receipt:", error);
        }
    };

    // ===================== HELPERS =====================
    const NumberToWords = (num) => {
        const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
        const teens = ['Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
        const tens = ['', 'Ten', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

        const convert = (num) => {
            if (num === 0) return '';
            if (num < 10) return units[num];
            if (num === 10) return tens[1];
            if (num < 20) return teens[num - 11];
            if (num < 100) return tens[Math.floor(num / 10)] + (num % 10 !== 0 ? ' ' + units[num % 10] : '');
            if (num < 1000) return units[Math.floor(num / 100)] + ' Hundred' + (num % 100 !== 0 ? ' ' + convert(num % 100) : '');
            if (num < 100000) return convert(Math.floor(num / 1000)) + ' Thousand' + (num % 1000 !== 0 ? ' ' + convert(num % 1000) : '');
            if (num < 10000000) return convert(Math.floor(num / 100000)) + ' Lakh' + (num % 100000 !== 0 ? ' ' + convert(num % 100000) : '');
            return 'Number is too large';
        };

        if (num === 0) return 'Zero';
        return convert(num).trim();
    };

    const ConvertAmountToRialBaisa = (amount) => {
        const formattedAmount = parseFloat(amount).toFixed(3); // keep 3 decimals
        const [rials, baisa] = formattedAmount.split('.');

        let words = `${NumberToWords(parseInt(rials))} Rial`;
        if (parseInt(rials) !== 1) words += "s"; // plural

        if (baisa && parseInt(baisa) > 0) {
            words += ` And ${NumberToWords(parseInt(baisa))} Baisa`;
        }
        return words + " Only";
    };

    return (
        <div className="w-full  mx-auto" style={{ width: '100%', marginTop: '10px' }}>
            <div className='w-full mb-2 flex'>
                <h6 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Receipt</h6>
                {loading && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999
                    }}>
                        <div>
                            <CircularProgress style={{ color: 'white' }} />
                            <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
                        </div>
                    </div>
                )}

                <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'left', marginTop: '-10px' }}>
                    <input
                        className="shadow text-gray-700 leading-tight"
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearch}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        style={{
                            width: isFocused ? '270px' : '200px',
                            height: '27px',
                            border: '1px solid #ccc',
                            borderRadius: '15px',
                            padding: '0 20px',
                            transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                            outline: 'none',
                            borderColor: isFocused ? 'darkcyan' : '#ccc',
                            boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                        }}
                    />
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px', marginTop: '-25px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ fontSize: '11px', height: '10px' }}>
                        From
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                        type="date" value={fromDate} onChange={handleFromDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px', marginTop: '-25px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ fontSize: '11px', height: '10px' }}>
                        To
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                        type="date" value={toDate} onChange={handleToDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>


                <Tooltip
                    title="Get Receipt Details" arrow
                    componentsProps={{
                        tooltip: {
                            sx: {
                                backgroundColor: '#0b627cff',
                                color: 'white',
                                border: '1px solid white',
                                fontWeight: 'bold',
                                boxShadow: 2,
                            },
                        },
                    }}
                >
                    <Button
                        style={{ backgroundColor: '#0b627cff', color: "whitesmoke", height: '30px', marginLeft: '10px', marginTop: '-0.95%' }}
                        onClick={fetchTableData}
                        className="linkcolor"
                    >
                        <span>Refresh</span>
                    </Button>
                </Tooltip>

                <Tooltip
                    title="Create Receipt" arrow
                    componentsProps={{
                        tooltip: {
                            sx: {
                                backgroundColor: '#045157ff',
                                color: 'whitesmoke',
                                border: '1px solid white',
                                fontWeight: 'bold',
                                boxShadow: 2,
                            },
                        },
                    }}
                >
                    <Button
                        style={{ background: 'linear-gradient(to right, #041815ff, #045157ff)', color: "whitesmoke", height: '30px', marginLeft: '10px', marginTop: '-0.95%' }}
                        component={Link}
                        to="/PaymentAndReceiptCreate"
                        className="linkcolor"
                    >
                        <span>Create</span>
                    </Button>
                </Tooltip>
            </div>

            <div className="watermark">
                <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
            </div>

            <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto', marginTop: '-0.75%' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#243642', width: '2500px' }}>
                            <TableCell style={{
                                background: 'linear-gradient(to right, #173B45, #173B45)', borderRadius: '5px', color: 'white',
                                fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                                top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '3px', borderRadius: '4px', textTransform: 'uppercase', width: '25px'
                            }}>
                                Sl.No
                            </TableCell>
                            <TableCell style={{
                                background: 'linear-gradient(to right, #173B45, #173B45)', borderRadius: '5px', color: 'white',
                                fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                                top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '3px', borderRadius: '4px', textTransform: 'uppercase', width: '25px'
                            }}>
                                BILL DATE
                            </TableCell>
                            <TableCell style={{
                                background: 'linear-gradient(to right, #173B45, #173B45)', borderRadius: '5px', color: 'white',
                                fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                                top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '3px', borderRadius: '4px', textTransform: 'uppercase', width: '50px'
                            }}>
                                BILL NO
                            </TableCell>
                            <TableCell style={{
                                background: 'linear-gradient(to right, #173B45, #173B45)', borderRadius: '5px', color: 'white',
                                fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                                top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '3px', borderRadius: '4px', textTransform: 'uppercase', width: '250px'
                            }}>
                                Customer
                            </TableCell>
                            <TableCell style={{
                                background: 'linear-gradient(to right, #173B45, #173B45)', borderRadius: '5px', color: 'white',
                                fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                                top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '3px', borderRadius: '4px', textTransform: 'uppercase', width: '250px'
                            }}>
                                Consignee
                            </TableCell>
                            <TableCell style={{
                                background: 'linear-gradient(to right, #173B45, #173B45)', borderRadius: '5px', color: 'white',
                                fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                                top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '3px', borderRadius: '4px', textTransform: 'uppercase', width: '160px'
                            }}>
                                Remarks
                            </TableCell>
                            <TableCell style={{
                                background: 'linear-gradient(to right, #173B45, #173B45)', borderRadius: '5px', color: 'white',
                                fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'right', position: 'sticky',
                                top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '3px', borderRadius: '4px', textTransform: 'uppercase', width: '100px'
                            }}>
                                Amount</TableCell>
                            <TableCell style={{
                                background: 'linear-gradient(to right, #173B45, #173B45)', borderRadius: '5px', color: 'white',
                                fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'right', position: 'sticky',
                                top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '3px', borderRadius: '4px', textTransform: 'uppercase', width: '100px'
                            }}>

                            </TableCell>
                        </TableHead>

                        <TableBody style={{ backgroundColor: '#F5F7F8' }}>
                            {sortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((data, index) => (
                                <TableRow
                                    key={data.id}
                                    className={'highlighted-row'}
                                    sx={{
                                        '&:hover': {
                                            backgroundColor: '#E3FEF7',
                                        },
                                    }}
                                >
                                    <TableCell className='table-header-cell.child' sx={{ padding: '3px', borderRight: '1px solid # #f4dfdfff', fontSize: '12px', width: '25px' }}>
                                        {index + 1}
                                    </TableCell>
                                    <TableCell className='table-header-cell.child' sx={{ padding: '3px', borderRight: '1px solid # #f4dfdfff', fontSize: '11.5px', width: '25px' }}>
                                        {formatDate(data.BillDate)}
                                    </TableCell>
                                    <TableCell className='table-header-cell.child' sx={{ padding: '3px', borderRight: '1px solid # #f4dfdfff', fontSize: '11.5px', width: '50px' }}>
                                        {data.BillNumber}
                                    </TableCell>
                                    <TableCell className='table-header-cell.child' sx={{ padding: '3px', borderRight: '1px solid # #f4dfdfff', fontSize: '11.5px', width: '210px' }}>
                                        {data.CustomerName}
                                    </TableCell>
                                    <TableCell className='table-header-cell.child' sx={{ padding: '3px', borderRight: '1px solid # #f4dfdfff', fontSize: '11.5px', width: '210px' }}>
                                        {data.ConsigneeName}
                                    </TableCell>
                                    <TableCell className='table-header-cell.child' sx={{
                                        padding: '3px', borderRight: '1px solid # #f4dfdfff',
                                        borderBottom: '1px solid #D4E2D4',
                                        color: data.Remarks === 'Remarks' ? 'red' : 'green',
                                        padding: '3px',
                                        textAlign: 'left',
                                        fontSize: '11.5px',
                                        fontWeight: 'bold',
                                        width: '210px'
                                    }}
                                    >
                                        {data.Remarks}
                                    </TableCell>

                                    <TableCell className='table-header-cell.child' sx={{ padding: '3px', borderRight: '1px solid # #f4dfdfff', textAlign: 'right', fontSize: '11.5px', width: '100px' }}>
                                        {data.Amount ? data.Amount.toFixed(3) : "0.000"}
                                    </TableCell>

                                    <TableCell className='table-header-cell.child' style={{ padding: '3px', borderRight: '1px solid # #f4dfdfff', textAlign: 'right', width: '140px' }}>
                                        {/* Receipt Print */}
                                        <Tooltip title="Receipt Print" arrow
                                            componentsProps={{
                                                tooltip: {
                                                    sx: {
                                                        backgroundColor: 'darkmagenta',
                                                        color: 'white',
                                                        border: '1px solid white',
                                                        fontWeight: 'bold',
                                                        boxShadow: 2,
                                                    },
                                                },
                                            }}>
                                            <IconButton size="small" onClick={() => generateInvoice(data.Id)}>
                                                <PrintIcon sx={{ fontSize: 18, color: 'darkmagenta' }} />
                                            </IconButton>
                                        </Tooltip>

                                        <Tooltip
                                            title="Receipt Details" arrow
                                            componentsProps={{
                                                tooltip: {
                                                    sx: {
                                                        backgroundColor: 'coral',
                                                        color: 'white',
                                                        border: '1px solid white',
                                                        fontWeight: 'bold',
                                                        boxShadow: 2,
                                                    },
                                                },
                                            }}>
                                            <IconButton component={Link} to={`/PaymentAndReceiptDetails/${data.Id}`}>
                                                <Info style={{ color: 'coral', height: '22px' }} />
                                            </IconButton>
                                        </Tooltip>

                                        {hasEditMasterPermission && (
                                            <Tooltip
                                                title="Receipt Edit" arrow
                                                componentsProps={{
                                                    tooltip: {
                                                        sx: {
                                                            backgroundColor: 'darkblue',
                                                            color: 'white',
                                                            border: '1px solid white',
                                                            fontWeight: 'bold',
                                                            boxShadow: 2,
                                                        },
                                                    },
                                                }}>
                                                <IconButton component={Link} to={`/PaymentAndReceiptEdit/${data.Id}`} >
                                                    <EditIcon style={{ height: '22px', color: 'darkblue' }} />
                                                </IconButton>
                                            </Tooltip>
                                        )}

                                        {hasDeleteMasterPermission && (
                                            <Tooltip
                                                title={data.IsActive ? "Payment & Receipt Delete" : "Payment & Receipt Activate"} arrow
                                                componentsProps={{
                                                    tooltip: {
                                                        sx: {
                                                            backgroundColor: '#DA6C6C',
                                                            color: 'white',
                                                            border: '1px solid white',
                                                            fontWeight: 'bold',
                                                            boxShadow: 2,
                                                        },
                                                    },
                                                }}
                                            >
                                                <IconButton onClick={() => (data.IsActive ? openConfirmDialog(data.Id) : handleActivate(data.Id))} color="error">
                                                    {data.IsActive ? <DeleteSweepIcon style={{ height: '22px', color: 'darkred' }} /> : <ActivateIcon style={{ color: 'darkolivegreen', height: '22px' }} />}
                                                </IconButton>
                                            </Tooltip>
                                        )}

                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>

                        <Dialog
                            open={confirmDialogOpen}
                            onClose={closeConfirmDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to delete this record?
                                </DialogContentText>
                            </DialogContent>

                            <DialogActions>
                                <button
                                    onClick={closeConfirmDialog}
                                    style={{
                                        backgroundColor: '#dc3545',
                                        color: '#ffffff',
                                        border: '1px solid #dc3545',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                        marginRight: '8px',
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleDelete}
                                    style={{
                                        backgroundColor: '#28a745',
                                        color: '#ffffff',
                                        border: '1px solid #28a745',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Confirm
                                </button>
                            </DialogActions>

                        </Dialog>
                    </Table>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={filteredData.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </TableContainer>
            </div>
        </div >

    );
}

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

export default PaymentAndReceiptIndex;

